import { InjectionToken } from '@angular/core';
export const LOGGER_TOKEN = new InjectionToken<Window>(
  'Logger object'
);
